import React, { Suspense } from 'react';
import AddProductHeader from '../components/Sellers/Profile/Products/AddProduct/components/AddProductHeader';
import AddProductContent from '../components/Sellers/Profile/Products/AddProduct/components/AddProductContent';
import { usePublicState } from '@/store/slices/publicSlice';

const AddProduct: React.FC = () => {
  const { isSidebarCollapsed } = usePublicState();

  return (
    <div className="min-h-[calc(100vh-64px)] bg-[#f3f4f6] dark:bg-dark-surface " data-testid="add-product-page">
      <div className={`mx-auto px-4 lg:px-4 transition-all duration-300 ${!isSidebarCollapsed ? 'w-full' : 'w-10/12'}`} data-testid="add-product-main-container">
        <AddProductHeader />
        <div className="mt-3" data-testid="add-product-content-wrapper">
          <Suspense>
            <AddProductContent />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default AddProduct;

